
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import horvat from "../../assets/horvat.jpg"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarHorvat({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar horvát fordító</title>
                <meta name='description' content="Ingyenes magyar horvát fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar horvát fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-horvat-fordito" />
            </Helmet>
            <h1>Magyar horvát fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és horvát nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={horvat} alt="horvát zászló"></img>
                </div>
                <p>A magyar és horvát nyelv két különböző nyelv, amelyek különböző nyelvcsaládokba tartoznak. A magyar ugor-altaikus nyelv, míg a horvát a délszláv nyelvek családjába tartozik. Íme néhány fontos különbség a két nyelv között:</p>


                <ul>
                    <li><b>Hangrendek</b>: A magyarban a szavak hangrendje szerint oszlanak meg magas és mély hangrendűekre, amelyek hatással vannak a nyelvtani szabályokra és az igék ragozására. A horvátban nincsenek hangrendek, így ez a jelenség nem létezik.</li>

                    <li><b>Hangzások</b>: Mindkét nyelvnek vannak olyan hangzásai, amelyek nem találhatóak meg a másikban. Például a magyarban vannak hangsúlyos hosszú magánhangzók (pl. "a", "á", "o", "ó"), amelyek a horvátban nincsenek jelen.</li>

                    <li><b>Ragozás</b>: A magyar nyelv rendkívül gazdag ragozású nyelv, amelyben a szavaknak többféle alakja van a különböző esetekben, számokban és névmódokban. A horvát is ragozott nyelv, de kevésbé bonyolult és szabályosabb, mint a magyar.</li>

                    <li><b>Szókincs</b>: Mivel a magyar és horvát különböző nyelvek, ezért természetesen a szókincsük is eltérő. Az alapvető szavak, mint például a számok vagy a testrészek, természetesen hasonlóak lehetnek, de az általános szókincs és a nyelv sajátosságai eltérőek.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a horvát nyelv nyelvtani struktúrája is eltérő. A magyar nyelvben a mondat szerkezete gyakran más, mint a horvátban. Például a szórend és a mondatok felépítése más lehet.</li>
                </ul>
                <div className="sectionbottom">
                    <Link to="/horvat-magyar-fordito">Horvát magyar fordító</Link>
                    <img src={horvat} alt="horvát zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>


            </section>
        </>

    )
}

export default MagyarHorvat;